<template>
  <div class="content">
    <BootstrapModal :showModal="showVerifyModal" :hideCloseBtn="true">
      <template v-slot:title>
        <h4>Verify Account</h4>
      </template>
      <template v-slot:content>
        <div class="form_content">
          <input
            v-if="!haveNoCode"
            v-model="verifyCode"
            type="text"
            class="form-control name-js"
            name="name"
            placeholder="Enter Verify code"
          />
          <button
            v-if="haveNoCode"
            class="btn btn-primary w-100"
            @click="sendVerifyEmail"
          >
            Send Verify Code
          </button>
          <button v-else class="btn btn-primary w-100" @click="applyVerifyCode">
            Aplly Verify Code
          </button>
        </div>
      </template>
    </BootstrapModal>
    <WebsiteContainer />
  </div>
</template>
<script>
import store from "../vuex/store";
import { DataService } from "../config/dataService";
import BootstrapModal from "@/components/BootstrapModal.vue";
import WebsiteContainer from "@/components/WebsiteContainer";

export default {
  components: {
    WebsiteContainer,
    BootstrapModal,
  },
  data() {
    return {
      showVerifyModal: false,
      haveNoCode: true,
      verifyCode: "",
    };
  },
  mounted() {
    this.isUserVerified();
  },

  methods: {
    async isUserVerified() {
      // if (localStorage.getItem("token")) {
      try {
        const res = await DataService.get("users/current");
        if (!res.data || !res.data.data) {
          localStorage.removeItem("token");
        }
        await store.dispatch("setUser", res.data.data);

        if (!this.isVerify) {
          this.showVerifyModal = true;
        }
      } catch (e) {
        console.log(e);
      }
      // }
    },
    async sendVerifyEmail() {
      try {
        const res = await DataService.post("users/send-verify-code", {
          email: store.state.users.email,
        });
        if (!res.data || !res.data.status) return;
        this.haveNoCode = false;
      } catch (e) {
        console.log(e);
      }
    },
    async applyVerifyCode() {
      try {
        const res = await DataService.post("users/verify", {
          verificationCode: this.verifyCode,
        });
        await this.isUserVerified();
        this.showVerifyModal = false;
      } catch (e) {
        console.log(e);
      }
    },
  },

  computed: {
    isVerify() {
      return store.state.users.verify;
    },
  },
};
</script>
<style scoped>
.form_content {
  gap: 20px;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
}
</style>
